export default {
  namespaced: true,
  state: { success: false, user: {} },
  mutations: {
    set(state, user) {
      if (user && user.userUID) {
        state.user = user;
        state.success = true;
      } else {
        state.user = null;
        state.success = false;
      }
    }
  },
  actions: {},
  modules: {}
};
